module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-4 col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Fecha")]), _vm._v(" "), _c('date-picker', {
    model: {
      value: (_vm.fechaActiva),
      callback: function($$v) {
        _vm.fechaActiva = $$v
      },
      expression: "fechaActiva"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-3 col-md-2"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Número")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.numero),
      expression: "filtros.numero"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.filtros.numero)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filtros.numero = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-4 col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Sucursal")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.sucursal),
      expression: "filtros.sucursal"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "",
      "id": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filtros.sucursal = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Todas")]), _vm._v(" "), _vm._l((_vm.sucursalesFiltro), function(sucursal) {
    return _c('option', {
      key: sucursal._id,
      domProps: {
        "value": sucursal._id
      }
    }, [_vm._v(_vm._s(sucursal.empresa.razonSocial) + "-" + _vm._s(sucursal.denominacion))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-4 col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Usuario")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.usuario),
      expression: "filtros.usuario"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.filtros.usuario)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filtros.usuario = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), (_vm.entregas.length > 0) ? _c('div', {
    staticClass: "row"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.entregasFiltradas), function(entrega) {
    return _c('tr', {
      key: entrega._id
    }, [_c('td', [_vm._v(_vm._s(entrega.numero))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("fechaCorta")(entrega.fechaEntrega)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entrega.usuario.displayName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entrega.proveedor.razonSocial))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entrega.sucursal.empresa.razonSocial) + "-" + _vm._s(entrega.sucursal.denominacion))]), _vm._v(" "), _c('td', [_c('select', {
      staticClass: "form-control",
      domProps: {
        "value": entrega.estado
      },
      on: {
        "change": function($event) {
          _vm.onChangeEstadoPedido(entrega._id, entrega.proveedor._id, $event)
        }
      }
    }, [_c('option', {
      attrs: {
        "value": "Recibido"
      }
    }, [_vm._v("Recibido")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "Cocina"
      }
    }, [_vm._v("Cocina")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "Empaquetado"
      }
    }, [_vm._v("Empaquetado")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "Despachado"
      }
    }, [_vm._v("Despachado")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "Entregado"
      }
    }, [_vm._v("Entregado")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "Cancelado"
      }
    }, [_vm._v("Cancelado")])])]), _vm._v(" "), _vm._m(2, true)])
  }))])]) : _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "text-center center-block"
  }, [_c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("No hay pedidos para la fecha seleccionada")])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal modal-pedido",
    attrs: {
      "data-backdrop": "static"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-dialog-centered modal-lg"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h4', [_vm._v("Crear nuevo pedido para el " + _vm._s(_vm._f("fechaDMA")(_vm.fechaActiva)))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Empresa")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pedido.sucursal),
      expression: "pedido.sucursal"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "",
      "id": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.pedido.sucursal = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.onChangeEmpresaPedido]
    }
  }, _vm._l((_vm.sucursales), function(sucursal) {
    return _c('option', {
      key: sucursal._id,
      domProps: {
        "value": sucursal._id
      }
    }, [_vm._v(_vm._s(sucursal.empresa.razonSocial) + "-" + _vm._s(sucursal.denominacion))])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Usuario")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pedido.usuario),
      expression: "pedido.usuario"
    }],
    ref: "slUsuariosEmpresa",
    staticClass: "form-control",
    attrs: {
      "name": "",
      "id": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.pedido.usuario = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Seleccione un usuario")]), _vm._v(" "), _vm._l((_vm.usuariosEmpresaSeleccionada), function(usuario) {
    return _c('option', {
      key: usuario._id,
      domProps: {
        "value": usuario._id
      }
    }, [_vm._v(_vm._s(usuario.displayName))])
  })], 2), _vm._v(" "), (_vm.pedidosUsuario.length > 0) ? _c('span', {
    staticClass: "label label-warning"
  }, [_vm._v("El usuario ya tiene " + _vm._s(_vm.pedidosUsuario.length) + " pedidos para esta fecha")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Combo")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pedido.combo),
      expression: "pedido.combo"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "",
      "id": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.pedido.combo = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Seleccione un combo")]), _vm._v(" "), _vm._l((_vm.combosUsuario), function(combo) {
    return _c('option', {
      key: combo._id,
      domProps: {
        "value": combo._id
      },
      on: {
        "select": function($event) {
          _vm.onChangeCombo(combo)
        }
      }
    }, [_vm._v(_vm._s(combo.combo.nombre))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Precio")]), _vm._v(" "), _c('input', {
    ref: "precio",
    staticClass: "form-control derecha",
    attrs: {
      "type": "text"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Estado")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pedido.estado),
      expression: "pedido.estado"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.pedido.estado = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "Recibido"
    }
  }, [_vm._v("Recibido")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Cocina"
    }
  }, [_vm._v("Cocina")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Empaquetado"
    }
  }, [_vm._v("Empaquetado")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Despachado"
    }
  }, [_vm._v("Despachado")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Entregado"
    }
  }, [_vm._v("Entregado")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Cancelado"
    }
  }, [_vm._v("Cancelado")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Subsidio(%)")]), _vm._v(" "), _c('input', {
    ref: "subsidio",
    staticClass: "form-control derecha",
    attrs: {
      "type": "number",
      "min": "0",
      "max": "100"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_vm._l((_vm.menuActivo), function(platosEnCategoria, idx) {
    return [_c('h4', [_vm._v(_vm._s(idx) + " (" + _vm._s(_vm.totalEnCategoria(platosEnCategoria)) + ")")]), _vm._v(" "), _c('table', {
      staticClass: "table table-striped"
    }, [_vm._m(3, true), _vm._v(" "), _c('tbody', _vm._l((platosEnCategoria), function(plato) {
      return _c('tr', {
        key: plato._id
      }, [_c('td', {
        staticClass: "col-xs-2"
      }, [_c('input', {
        staticClass: "form-control derecha",
        attrs: {
          "type": "number",
          "min": "0",
          "max": "9999",
          "value": "0"
        },
        on: {
          "change": function($event) {
            _vm.onChangeCantidadPlato(plato, $event)
          }
        }
      })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(plato.nombre))])])
    })), _vm._v(" "), _c('tfoot')], 1)]
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-center center-block"
  }, [_c('ul', {
    staticClass: "list-unstyled"
  }, _vm._l((_vm.errores), function(error) {
    return _c('li', {
      key: error
    }, [_c('span', {
      staticClass: "label label-danger"
    }, [_vm._v(_vm._s(error))])])
  })), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }, [_c('small', [_vm._v(_vm._s(_vm.getMultiplicador) + " pedidos")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "btn btn-success btn-fill",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.guardarEntrega($event)
      }
    }
  }, [_vm._v("Guardar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-fill-danger",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.onCloseModal($event)
      }
    }
  }, [_vm._v("Cancelar")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "text-center center-block"
  }, [_c('a', {
    staticClass: "btn btn-success btn-fill",
    attrs: {
      "data-toggle": "modal",
      "data-target": ".modal-pedido"
    }
  }, [_vm._v("Nuevo pedido")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Número")]), _vm._v(" "), _c('th', [_vm._v("Fecha")]), _vm._v(" "), _c('th', [_vm._v("Para")]), _vm._v(" "), _c('th', [_vm._v("Proveedor")]), _vm._v(" "), _c('th', [_vm._v("Cliente")]), _vm._v(" "), _c('th', [_vm._v("Estado")]), _vm._v(" "), _c('th', [_vm._v("Acciones")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "btn btn-default btn-xs"
  }, [_vm._v("+")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Cantidad")]), _vm._v(" "), _c('th', [_vm._v("Plato")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-10e3bb7a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pedido/AdminPedidosRoot.vue
// module id = 1110
// module chunks = 5